// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"dashboard-wrap__wrap--34HwD","inner":"dashboard-wrap__inner--2ZBP5"};